//#region src/styles/tokens.css.ts
var e = {
	font: {
		familyDisplay: "var(--font-family-display)",
		familyNumber: "var(--font-family-number)"
	},
	text: {
		secondaryOnBrand: "var(--text-secondary-on-brand)",
		warning: "var(--text-warning)",
		action: "var(--text-action)",
		tagPurple: "var(--text-tag-purple)",
		tagGreen: "var(--text-tag-green)",
		tagRed: "var(--text-tag-red)",
		tagBlue: "var(--text-tag-blue)",
		tagYellow: "var(--text-tag-yellow)",
		tagOrange: "var(--text-tag-orange)",
		tagGrey: "var(--text-tag-grey)",
		tagLightGrey: "var(--text-tag-light-grey)",
		tagLime: "var(--text-tag-lime)",
		progress: "var(--text-progress)",
		tagTeal: "var(--text-tag-teal)",
		navigation: "var(--text-navigation)",
		navigationActive: "var(--text-navigation-active)",
		primary: "var(--text-primary)",
		primaryOnBrand: "var(--text-primary-on-brand)",
		secondary: "var(--text-secondary)",
		tertiary: "var(--text-tertiary)",
		disabled: "var(--text-disabled)",
		brandMain: "var(--text-brand-main)",
		brandAccent: "var(--text-brand-accent)",
		brandAccentDarker: "var(--text-brand-accent-darker)",
		black: "var(--text-black)",
		white: "var(--text-white)",
		error: "var(--text-error)",
		errorSubtle: "var(--text-error-subtle)",
		success: "var(--text-success)",
		onProgress: "var(--text-on-progress)",
		toggleOff: "var(--text-toggle-off)",
		toggleOn: "var(--text-toggle-on)",
		toggleDisabled: "var(--text-toggle-disabled)"
	},
	border: {
		disabled: "var(--border-disabled)",
		error: "var(--border-error)",
		action: "var(--border-action)",
		brandMain: "var(--border-brand-main)",
		black: "var(--border-black)",
		white: "var(--border-white)",
		primary: "var(--border-primary)",
		secondary: "var(--border-secondary)",
		tertiary: "var(--border-tertiary)",
		brandAccent: "var(--border-brand-accent)",
		onBrandMain: "var(--border-on-brand-main)",
		accent15: "var(--border-accent-15)",
		autopilot: "var(--border-autopilot)"
	},
	fg: {
		primary: "var(--fg-primary)",
		secondary: "var(--fg-secondary)",
		disabled: "var(--fg-disabled)",
		brandMain: "var(--fg-brand-main)",
		error: "var(--fg-error)",
		warning: "var(--fg-warning)",
		action: "var(--fg-action)",
		textSelect: "var(--fg-text-select)",
		teal: "var(--fg-teal)",
		navigation: "var(--fg-navigation)",
		navigationActive: "var(--fg-navigation-active)",
		navigationLogo: "var(--fg-navigation-logo)",
		white: "var(--fg-white)",
		black: "var(--fg-black)",
		tertiary: "var(--fg-tertiary)",
		brandAccent: "var(--fg-brand-accent)",
		brandAccentDarker: "var(--fg-brand-accent-darker)",
		progress: "var(--fg-progress)",
		success: "var(--fg-success)",
		toggle: "var(--fg-toggle)",
		toggleHover: "var(--fg-toggle-hover)",
		togglePressed: "var(--fg-toggle-pressed)",
		toggleThumb: "var(--fg-toggle-thumb)",
		tennis50: "var(--fg-tennis-50)",
		tennis100: "var(--fg-tennis-100)"
	},
	bg: {
		primaryHover: "var(--bg-primary-hover)",
		secondaryFocused: "var(--bg-secondary-focused)",
		active: "var(--bg-active)",
		brandMain: "var(--bg-brand-main)",
		errorLight: "var(--bg-error-light)",
		errorDark: "var(--bg-error-dark)",
		warning: "var(--bg-warning)",
		success: "var(--bg-success)",
		action: "var(--bg-action)",
		tagRed: "var(--bg-tag-red)",
		tagBlue: "var(--bg-tag-blue)",
		tagOrange: "var(--bg-tag-orange)",
		tagLime: "var(--bg-tag-lime)",
		teal: "var(--bg-teal)",
		tagTeal: "var(--bg-tag-teal)",
		brandFocused: "var(--bg-brand-focused)",
		whiteHover: "var(--bg-white-hover)",
		whiteFocused: "var(--bg-white-focused)",
		navigationItemHover: "var(--bg-navigation-item-hover)",
		navigationItemActive: "var(--bg-navigation-item-active)",
		primary: "var(--bg-primary)",
		secondary: "var(--bg-secondary)",
		secondaryHover: "var(--bg-secondary-hover)",
		disabled: "var(--bg-disabled)",
		overlay: "var(--bg-overlay)",
		brandAccent: "var(--bg-brand-accent)",
		brandHover: "var(--bg-brand-hover)",
		brandNavigation: "var(--bg-brand-navigation)",
		brandLaunch: "var(--bg-brand-launch)",
		tagGrey: "var(--bg-tag-grey)",
		tagLightGrey: "var(--bg-tag-light-grey)",
		tagGreen: "var(--bg-tag-green)",
		tagYellow: "var(--bg-tag-yellow)",
		tagPurple: "var(--bg-tag-purple)",
		transparentHighAgent: "var(--bg-transparent-high-agent)",
		transparentLowAgent: "var(--bg-transparent-low-agent)",
		transparentLowest: "var(--bg-transparent-lowest)",
		progress: "var(--bg-progress)",
		toggleOff: "var(--bg-toggle-off)",
		toggleDisabled: "var(--bg-toggle-disabled)"
	},
	accent: { navigationLogo: "var(--accent-navigation-logo)" },
	shadow: { toggleFocus: "var(--shadow-toggle-focus)" },
	graphic: {
		partnershipBronze: "var(--graphic-partnership-bronze)",
		partnershipSilver: "var(--graphic-partnership-silver)",
		partnershipGold: "var(--graphic-partnership-gold)",
		partnershipPlatinum: "var(--graphic-partnership-platinum)",
		partnershipXBlack: "var(--graphic-partnership-x-black)",
		partnershipXWhite: "var(--graphic-partnership-x-white)",
		partnershipBronzeDarker: "var(--graphic-partnership-bronze-darker)",
		partnershipSilverDarker: "var(--graphic-partnership-silver-darker)",
		partnershipGoldDarker: "var(--graphic-partnership-gold-darker)",
		partnershipPlatinumDarker: "var(--graphic-partnership-platinum-darker)",
		partnershipXLighter: "var(--graphic-partnership-x-lighter)",
		statusBgBlue: "var(--graphic-status-bg-blue)",
		statusProgressBlue: "var(--graphic-status-progress-blue)",
		statusIconBlue: "var(--graphic-status-icon-blue)",
		statusIconPurple: "var(--graphic-status-icon-purple)",
		statusProgressPurple: "var(--graphic-status-progress-purple)",
		statusBgPurple: "var(--graphic-status-bg-purple)",
		statusIconGreen: "var(--graphic-status-icon-green)",
		statusProgressGreen: "var(--graphic-status-progress-green)",
		statusBgGreen: "var(--graphic-status-bg-green)",
		statusIconOrange: "var(--graphic-status-icon-orange)",
		statusProgressOrange: "var(--graphic-status-progress-orange)",
		statusBgOrange: "var(--graphic-status-bg-orange)",
		statusBgYellow: "var(--graphic-status-bg-yellow)",
		statusIconYellow: "var(--graphic-status-icon-yellow)",
		statusProgressYellow: "var(--graphic-status-progress-yellow)",
		statusIconRed: "var(--graphic-status-icon-red)",
		statusProgressRed: "var(--graphic-status-progress-red)",
		statusBgRed: "var(--graphic-status-bg-red)",
		statusIconGrey: "var(--graphic-status-icon-grey)",
		statusProgressGrey: "var(--graphic-status-progress-grey)",
		statusBgGrey: "var(--graphic-status-bg-grey)",
		statusIconTeal: "var(--graphic-status-icon-teal)",
		statusProgressTeal: "var(--graphic-status-progress-teal)",
		statusBgTeal: "var(--graphic-status-bg-teal)",
		illustrationFillDarkest: "var(--graphic-illustration-fill-darkest)",
		illustrationFillLight: "var(--graphic-illustration-fill-light)",
		illustrationFillLightest: "var(--graphic-illustration-fill-lightest)",
		illustrationFillDark: "var(--graphic-illustration-fill-dark)",
		illustrationFill70: "var(--graphic-illustration-fill-70)",
		illustrationFill50: "var(--graphic-illustration-fill-50)",
		illustrationFill30: "var(--graphic-illustration-fill-30)",
		animationBg: "var(--graphic-animation-bg)",
		animationToggleOutline: "var(--graphic-animation-toggle-outline)",
		animationToggleFill: "var(--graphic-animation-toggle-fill)",
		animationAccent: "var(--graphic-animation-accent)",
		animationIcon: "var(--graphic-animation-icon)",
		animationText: "var(--graphic-animation-text)"
	},
	typography: {
		heading2xlFontFamily: "var(--typography-heading-2xl-font-family)",
		heading2xlFontSize: "var(--typography-heading-2xl-font-size)",
		heading2xlLineHeight: "var(--typography-heading-2xl-line-height)",
		heading2xlFontWeight: "var(--typography-heading-2xl-font-weight)",
		headingLgFontFamily: "var(--typography-heading-lg-font-family)",
		headingLgFontSize: "var(--typography-heading-lg-font-size)",
		headingLgLineHeight: "var(--typography-heading-lg-line-height)",
		headingLgFontWeight: "var(--typography-heading-lg-font-weight)",
		headingXsFontFamily: "var(--typography-heading-xs-font-family)",
		headingXsFontSize: "var(--typography-heading-xs-font-size)",
		headingXsLineHeight: "var(--typography-heading-xs-line-height)",
		headingXsFontWeight: "var(--typography-heading-xs-font-weight)",
		bodyXlFontFamily: "var(--typography-body-xl-font-family)",
		bodyXlFontSize: "var(--typography-body-xl-font-size)",
		bodyXlLineHeight: "var(--typography-body-xl-line-height)",
		bodyXlFontWeight: "var(--typography-body-xl-font-weight)",
		bodySmFontFamily: "var(--typography-body-sm-font-family)",
		bodySmFontSize: "var(--typography-body-sm-font-size)",
		bodySmLineHeight: "var(--typography-body-sm-line-height)",
		bodySmFontWeight: "var(--typography-body-sm-font-weight)",
		number2xlFontFamily: "var(--typography-number-2xl-font-family)",
		number2xlFontSize: "var(--typography-number-2xl-font-size)",
		number2xlLineHeight: "var(--typography-number-2xl-line-height)",
		number2xlFontWeight: "var(--typography-number-2xl-font-weight)",
		numberXlFontFamily: "var(--typography-number-xl-font-family)",
		numberXlFontSize: "var(--typography-number-xl-font-size)",
		numberXlLineHeight: "var(--typography-number-xl-line-height)",
		numberXlFontWeight: "var(--typography-number-xl-font-weight)",
		numberLgFontFamily: "var(--typography-number-lg-font-family)",
		numberLgFontSize: "var(--typography-number-lg-font-size)",
		numberLgLineHeight: "var(--typography-number-lg-line-height)",
		numberLgFontWeight: "var(--typography-number-lg-font-weight)",
		numberMdFontFamily: "var(--typography-number-md-font-family)",
		numberMdFontSize: "var(--typography-number-md-font-size)",
		numberMdLineHeight: "var(--typography-number-md-line-height)",
		numberMdFontWeight: "var(--typography-number-md-font-weight)",
		numberSmFontFamily: "var(--typography-number-sm-font-family)",
		numberSmFontSize: "var(--typography-number-sm-font-size)",
		numberSmLineHeight: "var(--typography-number-sm-line-height)",
		numberSmFontWeight: "var(--typography-number-sm-font-weight)",
		number2xsFontFamily: "var(--typography-number-2xs-font-family)",
		number2xsFontSize: "var(--typography-number-2xs-font-size)",
		number2xsLineHeight: "var(--typography-number-2xs-line-height)",
		number2xsFontWeight: "var(--typography-number-2xs-font-weight)"
	},
	ui: {
		smFontFamily: "var(--ui-sm-font-family)",
		smFontSize: "var(--ui-sm-font-size)",
		smLineHeight: "var(--ui-sm-line-height)",
		smFontWeight: "var(--ui-sm-font-weight)",
		mdFontFamily: "var(--ui-md-font-family)",
		mdFontSize: "var(--ui-md-font-size)",
		mdLineHeight: "var(--ui-md-line-height)",
		mdFontWeight: "var(--ui-md-font-weight)",
		mdStrongFontWeight: "var(--ui-md-strong-font-weight)",
		smStrongFontWeight: "var(--ui-sm-strong-font-weight)"
	},
	caption: {
		mdFontFamily: "var(--caption-md-font-family)",
		mdFontSize: "var(--caption-md-font-size)",
		mdLineHeight: "var(--caption-md-line-height)",
		mdFontWeight: "var(--caption-md-font-weight)"
	},
	label: {
		mdFontFamily: "var(--label-md-font-family)",
		mdFontSize: "var(--label-md-font-size)",
		mdLineHeight: "var(--label-md-line-height)",
		mdFontWeight: "var(--label-md-font-weight)"
	},
	button: {
		mdFontFamily: "var(--button-md-font-family)",
		mdFontSize: "var(--button-md-font-size)",
		mdLineHeight: "var(--button-md-line-height)",
		mdFontWeight: "var(--button-md-font-weight)"
	},
	tag: {
		mdFontFamily: "var(--tag-md-font-family)",
		mdFontSize: "var(--tag-md-font-size)",
		mdLineHeight: "var(--tag-md-line-height)",
		mdFontWeight: "var(--tag-md-font-weight)",
		mdLetterSpacing: "var(--tag-md-letter-spacing)"
	},
	radius: {
		none: "var(--radius-none)",
		xs: "var(--radius-xs)",
		md: "var(--radius-md)",
		lg: "var(--radius-lg)",
		xl: "var(--radius-xl)",
		"2xl": "var(--radius-2xl)",
		"4xl": "var(--radius-4xl)",
		"5xl": "var(--radius-5xl)",
		"6xl": "var(--radius-6xl)",
		full: "var(--radius-full)"
	},
	corner: {
		md: "var(--corner-md)",
		lg: "var(--corner-lg)",
		xl: "var(--corner-xl)"
	},
	partnership: {
		colorBronze: "var(--partnership-color-bronze)",
		colorSilver: "var(--partnership-color-silver)",
		colorGold: "var(--partnership-color-gold)",
		colorPlatinum: "var(--partnership-color-platinum)",
		colorXBlack: "var(--partnership-color-x-black)",
		colorXWhite: "var(--partnership-color-x-white)"
	}
};
//#endregion
export { e as t };
